import { useContext } from 'react';
import { LeadManagementContext } from '../contexts/LeadManagementContextProvider';
import useQueryParamsNext from './useQueryParamsNext';

export default function useOpenRenterDetails() {
  const { isArchivedFolder, isReportedFolder } = useContext(LeadManagementContext);
  const { updateQueryParams } = useQueryParamsNext();

  const openRenterDetails = (conversationId: string) => {
    updateQueryParams({
      queryParamValues: {
        conversationId,
      },
      shouldReplaceHistory: true,
    });
  };

  return {
    // The table skips the drawer for these folders when a conversationId lands in the URL.
    canOpenRenterDetails: !isArchivedFolder && !isReportedFolder,
    openRenterDetails,
  };
}
